import { DatePipe, DOCUMENT, Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CruiseService } from '../services/cruise.service';
import { LandingPageService } from '../services/landingpage.service';
import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit, PLATFORM_ID, Inject, AfterViewInit } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import { animate, style, transition, trigger } from '@angular/animations';
import { GalleryComponent } from './gallery/gallery.component';
import { MatDialog } from '@angular/material/dialog';

declare var $: any;
declare var jQuery: any;
declare var window: any;
@Component({
  selector: 'app-cruisedetails',
  templateUrl: './cruisedetails.component.html',
  styleUrls: ['./cruisedetails.component.css'],
  animations: [
    trigger('readAnim', [
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('.150s linear', style({ height: 0, opacity: 0 }))
      ]),
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('.150s linear', style({ height: '*', opacity: 1 }))
      ])
    ])
  ]
})
export class CruiseDetailsComponent implements OnInit {
  title = 'Cruize';
  public cabinOfferscheck: any = '';
  lead: any = {
    name: "",
    email: "",
    phone: "",
    city: "",
    cruiseName: ""
  };
  public showComm: boolean = false;
  Room = '';
  informat = '';
  selectedFARE: string = "";
  sailDateup = '';
  CategoryName = '';
  imagename = '';
  public roomdets: any = {};
  private roomValidate: any = 'Yes';
  public slideIndex: number = 1;
  public paxcount: number = 1;
  public checkterm: any = '';
  public vessel: any[] = [];
  public farebasis: any[] = [];
  cruiseDetails: any; cruiseGallery: any;
  public cruise: any = {};
  public cruisegal: any = {};
  tcsAmt: any;
  Type = '';
  imageurl = '';
  htmlInfo = '';
  room: any = {};
  cruiseData: any = {};
  public agentid: any = "";
  public roomsave: any = "";
  public cruiselineCruises: any[] = [];
  contactInfo: any; userType: any = 'B2C';
  gstInfo: any = {};
  dicountInfo: any; AgentUserLoginId: any = ''; public movetolist: any = ''; public farebase: any = '';
  sailDate: any;
  sailMonths: any[] = [];
  activeRoom: any = {
    type: "Interior",
    adults: 2,
    childs: 0,
    infants: 0
  };
  public isUserLoggedIn: any = false;
  public isAgentLoggedIn: any = false;
  public user: any = {};
  public agent: any = {};
  dates: any;
  roomQry = '';
  public loginType = '';
  public fullURL = ''; private baseURL: any = ''; private logindata: any = ''; private rooms: any = ''; public deck: any; public agentcode: any = "";
  public srplink = ''; public srptxt = ''; public srpselected = ''; public finalsrpselected = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private route: ActivatedRoute, private landingPageService: LandingPageService,
    private toastr: ToastrService, private sanatize: DomSanitizer, private cruiserService: CruiseService,
    platformLocation: PlatformLocation, private location: Location, private routr: Router, private titleService: Title, private meta: Meta, @Inject(DOCUMENT) private dom, private dialog: MatDialog) {
    // Get Agent Login
    this.fullURL = (platformLocation as any).location.href; this.baseURL = (platformLocation as any).location.origin;
    this.route.params.subscribe(params => {
      this.cruiseData = params["searchstring"].split("---");
      if (isPlatformBrowser(this.platformId)) {
        sessionStorage.removeItem("deckinfo");
        try {
          this.room = JSON.parse(sessionStorage.getItem("room") || '');
        } catch (errormsg) {
          this.room = this.activeRoom; sessionStorage.setItem("room", JSON.stringify(this.activeRoom));
        }
      }
      if (!this.room) {
        this.room = this.activeRoom;
        if (isPlatformBrowser(this.platformId)) sessionStorage.setItem("room", JSON.stringify(this.activeRoom));
      }
      this.dates = this.cruiseData[4];

      if (this.room.type == 1) {
        this.room.type = "Mini Suite";
      } else if (this.room.type == 2) {
        this.room.type = "Balcony";
      } else if (this.room.type == 3) {
        this.room.type = "Ocean View";
      } else if (this.room.type == 4) {
        this.room.type = "Interior";
      }
      this.cruiseData[5] = this.room.type + "," + this.room.type + "," + this.room.adults + "," + this.room.childs + "," + this.room.infants;
      // this.srplink = "list/---------" + this.cruiseData[0].split(' ').join('-') + "------" + this.cruiseData[5];
      this.getPricingDetails();
    })
    this.loginType = this.cruiserService.getloginType();
    try {
      if (isPlatformBrowser(this.platformId)) {
        if (sessionStorage.getItem("logindata")) {
          this.logindata = JSON.parse(JSON.parse(sessionStorage.getItem("logindata")));
          this.AgentUserLoginId = this.logindata.AgentUserLoginId;
        }
      }
    } catch (errormsg) { console.log(errormsg) };

    // this.getParams();

  }
  public ngAfterViewInit() {
    $('#horizontalTab1').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion          
    });
    $('#horizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion          
    });
    $('#verticalTab1').easyResponsiveTabs({
      type: 'vertical', //Types: default, vertical, accordion
    });
  }

  public ngOnInit() {
    window.scrollTo(0, 0);
    $("#waitingIconHD").modal("show");
    this.paxcount = Number(this.room.adults) + Number(this.room.childs) + Number(this.room.infants);
  }

  createLead() {
    console.log(this.lead);
    var status = true;
    if (this.lead.name == "") {
      this.toastr.warning("Name is required...");
      return false;
    }
    if (this.lead.phone == "") {
      this.toastr.warning("Phone Number is required...");
      return false;
    }
    if (this.lead.email == "") {
      this.toastr.warning("Please provide Email...");
      return false;
    }
    else {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(this.lead.email)) {
        this.toastr.warning("Please provide Correct Email...");
        return false;
      }
    }
    if (this.checkterm == '') {
      this.toastr.warning("I authorize akbartravels to contact me and have read the Terms and Conditions.");
      return false;
    }
    this.cruiserService.createLead(this.lead, this.AgentUserLoginId, JSON.stringify(this.logindata)).subscribe(
      data => {
        this.toastr.success("Request Submitted successfully...");
        this.lead.name = ""; this.lead.email = ""; this.lead.phone = "";
        this.lead.city = ""; this.lead.cruiseName = "";
      },
      error => {
        this.toastr.error("Something went wrong...")
      }
    )
    $('#exampleModalCenterSend').click();
    $('.exampleModalCenterSend').toggleClass('show');
    $('.exampleModalCenterSend').remove();
    return status;
  }
  showdata(event) {
    this.sailDateup = event;
  }
  public openSendQuery(cruise) {
    this.lead.cruiseName = cruise.CruiseCode;
  }
  getPricingDetails() {
    try {
      var arr = this.cruiseData[4].split("-");
      this.room.date = arr[2] + "-" + arr[1] + "-" + arr[0];
    } catch (errormsg) {
      this.room.date = this.cruiseData[4];
    }

    try {
      //this.srplink = "/list/";
      this.srptxt = this.cruiseData[0].split('-').join(' ') + " / " + this.cruiseData[1].split('-').join(' ');
      var pax = this.cruiseData[5].split(',');
      this.srpselected = this.room.date + ", 1 Cabin(s), " + pax[2].substring(0, 1) + " Adult(s), " + pax[3].substring(0, 1) + " Child(s) ";
      this.finalsrpselected = pax[2].substring(0, 1) + " Adult(s), " + pax[3].substring(0, 1) + " Child(s) " + "| 1 x Cabin Room";
    }
    catch (errormsg) { }

    this.sailDate = this.room.date;
    //this.room.type = this.getRoomType(this.room.type);
    this.room.type = this.cruiseData[5].split(',')[0];
    this.room.adults = this.cruiseData[5].split(',')[2].substring(0, 1);
    this.room.childs = this.cruiseData[5].split(',')[3].substring(0, 1);
    this.room.infants = this.cruiseData[5].split(',')[4].substring(0, 1);
    this.roomsave = this.room.type + "," + this.room.type + "," + this.room.adults + "," + this.room.childs + "," + this.room.infants + "|";
    this.roomdets = {
      room: this.roomsave,
      date: this.dates,
    }
    console.log(this.cruiseData[0], this.cruiseData[1], this.cruiseData[2], this.cruiseData[3], this.room);

    this.cruiserService.getPricingDetailsnew(this.cruiseData[0], this.cruiseData[1], this.cruiseData[2], this.cruiseData[3], this.roomdets, this.selectedFARE, this.loginType, this.agentcode, this.AgentUserLoginId).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'failed') {
          this.toastr.warning("Seems no Live Sailings available, try some other destination/sailing !");
          setTimeout(() => {
            this.location.back();
          }, 2000);
          return false;
        }
        setTimeout(() => {
          $("#closeWaiting").click();
          $('.modal-backdrop').remove();

          $('#waitingIconHD').modal('toggle');
          $('#waitingIconHD').hide();
          $('#waitingIconHD').removeClass("show")
        }, 500);
        this.cruise = resp.cruisePriceData[0];
        this.cruisegal = this.cruise.cabinPrice[0];
        if (this.cruisegal.nettpayable == 0) this.toastr.warning("Rates are not available for Selected Cabin, Try another Cabin");
        this.cabinOfferscheck = this.cruise.cabinOffers; this.cruiseGallery = this.cruise.gallery;
        sessionStorage.setItem("cruisegallery", JSON.stringify(this.cruiseGallery));
        for (let m of this.cruise.cabins) {
          if ((this.cruisegal.cabintype).toUpperCase() == (m.CategoryName).toUpperCase()) {
            this.imagename = m.ImageURL;
            this.CategoryName = m.CategoryName;
            this.informat = m.Info;
          }
        }
        this.sailMonths = this.cruise.SailingDates;
        this.setFistTabActive();
        setTimeout(() => {
          $('.owl-carousel.banner').owlCarousel({
            margin: 30,
            autoplay: true,
            loop: false,
            rewind: true,
            autoplayTimeout: 2500,
            lazyLoad: true,
            nav: true,
            navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
            responsive: {
              0: { items: 1, },
              576: { items: 2, },
              768: { items: 2, },
              992: { items: 2, }
            }
          });
        }, 1000);
        this.farebasisList(); this.vesselslist();
        try {
          this.titleService.setTitle("Book " + this.cruise.Nights + " " + this.cruise.FriendlyCruiseName);
          this.meta.addTag({ name: 'author', content: 'http://www.influencetechnolabs.com/' });
        } catch (errormsg) { }
        return true;
      },
      error => {
        console.log(error);
      }
    )
  }
  // getcruiselineCruise(cruiseline) {
  //   this.cruiselineCruises = [];
  //   this.cruiseService.getInternationalCruise('cruise', "", cruiseline).subscribe(
  //     data => {
  //       let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
  //       if (resp.status == 'success') {
  //         this.cruiselineCruises = resp.cruiseMaster;
  //         this.resetCarousel1();
  //       }
  //     }, error => {
  //       console.log(error);
  //     }
  //   )
  // }

  private setFistTabActive() {
    let x: number;
    //$(".tablinks")[0].className += " active";
    let tab1 = document.getElementById(" Salon & Fitness At Sea");
    if (tab1)
      tab1.style.display = "block";
    for (x = 0; x < this.cruise.onboard.length; x++) {
      if (this.cruise.onboard[x].CategoryName == ' Salon & Fitness At Sea') {
        this.imageurl = this.cruise.onboard[x].ImageURL;
        this.htmlInfo = this.cruise.onboard[x].Info;
      }
    }
  }
  public openactvty(evt: any, cityName: string, ImageURL, Info) {
    let i;
    this.imageurl = ImageURL;
    this.htmlInfo = Info;
    let tabcontent: any = $('.tabcontent');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    let tablinks = $(".tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    let city = document.getElementById(cityName);
    if (city)
      city.style.display = "block";
    evt.currentTarget.className += " active";
  }
  getCruiseDetails(cruise, type) {
    var qstring = "";
    if (type == 'trending' || type == 'Trending cruises') {
      qstring = "---------" + cruise.CruiseLine.split(' ').join('-') + "------Interior,Interior,2A,0C,0I|";
    }
    if (type == 'international' || type == 'domestic' || type == 'cruiseline') {
      qstring = "---------" + "" + "---" + cruise.CruiseCode;
    }
    if (type == 'exclusive' || type == 'Exclusive Deals') {
      qstring = "---------" + cruise.CruiseLine.split(' ').join('-') + "------Interior,Interior,2A,0C,0I|";
    }

    console.log(cruise);
    this.routr.navigate(["list/" + qstring]);
  }
  methodeven(n) {
    return n % 2 == 0;
  }
  methododd(n) {
    return Math.abs(n % 2) == 1;
  }
  upgrade() {
    this.cruiseData[4] = this.sailDateup;
    try {
      var arr = this.cruiseData[4].split("-");
      this.room.date = arr[2] + "-" + arr[1] + "-" + arr[0];
    } catch (errormsg) {
      this.room.date = this.cruiseData[4];
    }
    //this.room.type = this.Room;
    this.room.adults = this.cruiseData[5].split(',')[2].substring(0, 1);
    this.room.childs = this.cruiseData[5].split(',')[3].substring(0, 1);
    this.room.infants = this.cruiseData[5].split(',')[4].substring(0, 1);
    this.roomsave = this.room.type + "," + this.room.type + "," + this.room.adults + "," + this.room.childs + "," + this.room.infants + "|";
    try {
      this.srplink = "/list/";
      this.srptxt = this.cruiseData[0].split('-').join(' ') + " / " + this.cruiseData[1].split('-').join(' ');
      var pax = this.cruiseData[5].split(',');
      //this.paxname = this.cruiseData[5].split(',')[2] + "," + this.cruiseData[5].split(',')[3];
      //this.roomname = this.Room;
      this.srpselected = this.room.date + ", 1 Cabin(s), " + pax[2].substring(0, 1) + " Adult(s), " + pax[3].substring(0, 1) + " Child(s) ";
      this.finalsrpselected = pax[2].substring(0, 1) + " Adult(s), " + pax[3].substring(0, 1) + " Child(s) " + "| 1 x Cabin Room";
    }
    catch (errormsg) { }

    this.sailDate = this.room.date;
    //this.room.type = this.getRoomType(this.room.type);
    //this.room.type = this.Room;
    this.roomdets = {
      room: this.roomsave,
      date: this.room.date,
    }
    let url = this.cruise.CruiseLine.split('/')[0].split(' ').join('-') + "---" + this.cruise.ShipName.split(' ').join('-')
      + "---" + this.cruise.FriendlyCruiseName.split(' ').join('-') + "---"
      + this.cruise.Nights.split(' ').join('-') + "---" + this.room.date;
    console.log(this.cruiseData[0], this.cruiseData[1], this.cruiseData[2], this.cruiseData[3], this.room);
    sessionStorage.setItem("room", JSON.stringify(this.room));
    $("#closeWaiting").click();
    $('.modal-backdrop').remove();
    $('#exampleModalCenter').modal('toggle');
    $('#exampleModalCenter').hide();
    $('#exampleModalCenter').removeClass("show")
    $("#closeWaiting").click();
    $('.modal-backdrop').remove();
    $('#waitingIconHD').modal('toggle');
    $('#waitingIconHD').hide();
    $('#waitingIconHD').removeClass("show")
    this.routr.navigate(["cruise-details/" + this.cruise.CruiseLine.split('/')[0].split(' ')[0] + "/" + url]);

    // this.cruiserService.getPricingDetailsnew(this.cruiseData[0], this.cruiseData[1], this.cruiseData[2], this.cruiseData[3], this.roomdets, this.selectedFARE, this.loginType, this.agentcode, this.AgentUserLoginId).subscribe(
    //   data => {
    //     let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
    //     if (resp.status == 'failed') {
    //       this.toastr.warning("Seems no Live Sailings available, try some other destination/sailing !");
    //       setTimeout(() => {
    //         this.location.back();
    //       }, 2000);
    //       return false;
    //     }
    //     $("#closeWaiting").click();
    //     $('.modal-backdrop').remove();
    //     $('#exampleModalCenter').modal('toggle');
    //     $('#exampleModalCenter').hide();
    //     $('#exampleModalCenter').removeClass("show")
    //     this.cruise = resp.cruisePriceData[0];
    //     this.cruisegal = this.cruise.cabinPrice[0];
    //     this.cabinOfferscheck = this.cruise.cabinOffers;
    //     this.sailMonths = this.cruise.SailingDates;
    //     this.setFistTabActive();
    //     if (this.cruisegal.nettpayable == 0) this.toastr.warning("Rates are not available for Selected Cabin, Try another Cabin");
    //     return true;
    //   },
    //   error => {
    //     console.log(error);
    //   }
    // )
  }
  vesselslist() {
    this.cruiserService.getvessels(this.cruise.CruiseCode, this.paxcount, this.room.date, this.room.type, "vesselslist").subscribe(data => {
      this.vessel = JSON.parse(JSON.parse(JSON.stringify(data)).d).data.cabin_category;
      this.vessel = this.vessel.sort((a, b) => a.Price - (b.Price));
    }, error => console.log(error));
  }
  farebasisList() {
    this.cruiserService.getvessels(this.cruise.CruiseCode, this.paxcount, this.room.date, this.room.type, "farebasisList").subscribe(data => {
      this.farebasis = JSON.parse(JSON.parse(JSON.stringify(data)).d).cabin_category;
    }, error => console.log(error));
  }
  voucher_validate(event) {
    var adult = this.cruiseData[5].split(',')[2].substring(0, 1);
    var child = this.cruiseData[5].split(',')[3].substring(0, 1);
    var infant = this.cruiseData[5].split(',')[4].substring(0, 1);
    var category = this.Room.split(',')[0];
    var total = Number(adult) + Number(child) + Number(infant);
    this.roomValidate = "Yes";
    if (category.indexOf('Suite') > -1 && total > 4) {
      this.toastr.error("Total Members in Suite should not exceed 4");
      this.roomValidate = "No";
      return false;
    } else if (category.indexOf('Balcony') > -1 && total > 3) {
      this.toastr.error("Total Members in Balcony should not exceed 3");
      this.roomValidate = "No";
      return false;
    }
    else if (category.indexOf('Oceanview') > -1 && total > 4) {
      this.toastr.error("Total Members in Ocean View should not exceed 4");
      this.roomValidate = "No";
      return false;
    }
    else if (category.indexOf('Interior') > -1 && total > 4) {
      this.toastr.error("Total Members in Interior should not exceed 4");
      this.roomValidate = "No";
      return false;
    }
  }

  termc(event) {
    if (event.target.checked == true) {
      this.checkterm = 'check';
    }
    else {
      this.checkterm = '';
    }
  }

  bookcruise(Cruisedatalist?, sailingdate?, cabintype?) {
    if (this.cruisegal.nettpayable == 0) {
      this.toastr.warning("Rates are not available for Selected Cabin, Try another Cabin");
      return false;
    }
    var location = Cruisedatalist.location + " Cruise";
    var postData = Cruisedatalist.CruiseLine.split('/')[0].split(' ').join('-') + "---" + Cruisedatalist.ShipName.split(' ').join('-') + "---" + Cruisedatalist.FriendlyCruiseName.split(' ').join('-') + "---" + Cruisedatalist.Nights.split(' ').join('-') + "---";
    if (this.dates != "") postData += this.dates + "---"; else postData += Cruisedatalist.sailMonths[0].sailM
    if (this.roomQry != "") { postData += this.roomQry; }
    this.room.type = cabintype;
    // else { postData += cabintype + "," + cabintype + "," + this.cruiseData[5].split(',')[2] + "," + this.cruiseData[5].split(',')[3] + "," + this.cruiseData[5].split(',')[4]; }
    sessionStorage.setItem("Cruisedataprice", JSON.stringify(Cruisedatalist));
    sessionStorage.setItem("room", JSON.stringify(this.room));
    this.routr.navigate(["pax-details/traveller/" + postData]);
  }

  updateSearch(type) {
    // this.room.adults = this.cruiseData[5].split(',')[2].substring(0, 1);
    // this.room.childs = this.cruiseData[5].split(',')[3].substring(0, 1);
    // this.room.infants = this.cruiseData[5].split(',')[4].substring(0, 1);
    let total = Number(this.room.adults) + Number(this.room.childs) +
      Number(this.room.infants);
    this.room.type = type; this.farebase = '';

    this.room.date = this.dates.split('-')[2] + "-" + this.dates.split('-')[1] + "-" + this.dates.split('-')[0];
    if ((this.room.type == "1" || this.room.type.indexOf("Suite") > -1) && total > 3) {
      this.toastr.error("Total Members in Mini Suite should not exceed 3");
      return false;
    } else if ((this.room.type == "2" || this.room.type.indexOf("Balcony") > -1) && total > 3) {
      this.toastr.error("Total Members in Balcony should not exceed 3");
      return false;
    } else if ((this.room.type == "3" || this.room.type.indexOf("Ocean View") > -1) && total > 4) {
      this.toastr.error("Total Members in Ocean View should not exceed 4");
      return false;
    } else if ((this.room.type == "4" || this.room.type.indexOf("Interior") > -1) && total > 4) {
      this.toastr.error("Total Members in Interior should not exceed 4");
      return false;
    }
    let url = this.cruiseData[0] + "---" + this.cruiseData[1]
      + "---" + this.cruiseData[2] + "---" + this.cruiseData[3] + "---" + this.dates;
    //+ "---" + this.room.type + "," + this.room.type + "," + this.room.adults + "," + this.room.childs + "," + this.room.infants;
    if (isPlatformBrowser(this.platformId)) sessionStorage.setItem("room", JSON.stringify(this.room));
    this.routr.navigate(["cruise-details/" + this.cruiseData[0] + "/" + url]);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  getRoomType(type) {
    if (type == 1) {
      return "Mini Suite";
    } else if (type == 2) {
      return "Balcony";
    } else if (type == 3) {
      return "Ocean View";
    } else {
      return "Interior";
    }
  }

  sorting(column) {
    if (this.showComm) {
      this.showComm = false;
    } else { this.showComm = true; }
  }

  openGallery(gallery, clickFromView: boolean = true) {
    if (!clickFromView) {
      if (window.innerWidth > 1200) {
        return;
      }
    }
    this.dialog.open(GalleryComponent, { panelClass: 'custom-gallery-panel-class' });
  }
}
